import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'hub-additional-information',
  standalone: true,
  imports: [DividerModule, DatePipe],
  templateUrl: './additional-information.component.html',
  styleUrl: './additional-information.component.scss',
})
export class AdditionalInformationComponent {
  @Input() processId!: any;
  @Input() processName: string = '';
  @Input() processCreatedDate: string = '';
}
